<template>
      <div id="app" v-if="isLoaded">
            <navigation></navigation>
            <newsletter></newsletter>
            <cart></cart>
            <router-view :key="$route.fullPath"></router-view>
            <lp-footer></lp-footer>
      </div>
</template>

<script>
const Navigation = () =>
  import(/* webpackChunkName: "Navigation" */ "@/components/Navigation.vue");
const Cart = () =>
  import(/* webpackChunkName: "Cart" */ "@/components/Cart.vue");
const Newsletter = () =>
  import(/* webpackChunkName: "Newsletter" */ "@/components/Newsletter.vue");
const LpFooter = () =>
  import(/* webpackChunkName: "Footer" */ "@/components/Footer.vue");

export default {
  components: {
    Navigation,
    Cart,
    Newsletter,
    LpFooter
  },
  data() {
    return {
      isLoaded: false
    };
  },
  beforeCreate() {
    this.$store.dispatch("loadSite").then(() => {
      this.isLoaded = true;
    });
    this.$store.dispatch("loadCategories");
  },
  computed: {
    site() {
      return this.$store.state.site;
    }
  }
};
</script>

<style lang="scss">
@import "node_modules/reset-css/sass/_reset";
* {
  box-sizing: border-box;
}
@font-face {
  font-family: "Liga";
  src: url("/public/fonts/HomeFuture25-Medium.woff");
  font-style: normal;
  font-weight: 400;
  font-display: swap;
}
@font-face {
  font-family: "Lundi";
  src: url("/public/fonts/Lundi_11-HumanKind.woff");
  font-style: normal;
  font-weight: 400;
  font-display: swap;
}

.lundi {
  font-family: "Lundi", sans-serif;
}
.ls {
  letter-spacing: 0.05rem;
}

.no-select {
  user-select: none;
}

::selection {
  background-color: var(--orange);
  color: white;
}

.link,
a,
a:active,
a:visited {
  color: black;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    color: var(--grey);
  }
}

:root {
  --fs: 1rem;
  --lh: calc(1.25 * 1rem);
  --grey: rgba(0, 0, 0, 0.25);
  --orange: rgba(255, 100, 0, 1);
  --active: rgba(0, 0, 0, 0.8);
  --pad: calc(0.5 * var(--lh)) calc(0.75 * var(--lh));
  @media only screen and (max-width: 768px) {
    --fs: 0.8rem;
    --lh: calc(1.25 * 0.8rem);
  }
}

body,
html {
  width: 100%;
  // height: 100%;
}

#app {
  width: 100%;
  // height: 100%;
  overflow-x: hidden;
  font-family: "Liga", Arial, sans-serif;
  // font-feature-settings: "dlig";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: var(--fs);
  line-height: var(--lh);
  header {
    padding: 1rem;
    background: #eee;
    display: flex;
    justify-content: space-between;
  }
  main {
    width: calc(100% + 2px);
    min-height: 100vh;
    padding: calc(2 * var(--lh)) 0;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
    transition: opacity 1s;
    &[lazy="loading"] {
      opacity: 0;
    }
    &[lazy="loaded"] {
      opacity: 1;
    }
    &.contain {
      object-fit: contain;
    }
  }
  .orange {
    background: var(--orange);
  }

  .li {
    border-bottom: 1px solid #000;
    position: relative;
  }
  .pad {
    padding: var(--pad);
  }
  .inline {
    display: inline-block !important;
  }
  .sli {
    padding: var(--pad);
    border-right: 1px solid #000;
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: center;
    &:last-of-type {
      border-right: 0;
    }
    &.top {
      justify-content: flex-start;
    }
  }
  .tooltip {
    color: var(--orange);
    font-size: calc(0.75 * var(--fs));
    &.black {
      color: #000;
    }
    &.grey {
      color: rgba(0, 0, 0, 0.5);
    }
  }
  .grid {
    display: grid;
  }
  .g-6 {
    grid-template-columns: repeat(12, 1fr);
    position: relative;
    &:after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 1px;
      background: white;
    }
  }
  @media only screen and (max-width:768px) {
      .g-1-mobile {
            grid-template-columns: repeat(6, 1fr);
      }
      .no-mobile {
            display:none;
      }
  }
  .quarter {
    grid-column: span 3;
  }
  .third {
    grid-column: span 4;
  }
  .half {
    grid-column: span 6;
  }
  .twothird {
    grid-column: span 8;
  }
  .threequarter {
    grid-column: span 9;
  }
  .full {
    grid-column: span 12;
  }
  .image,
  .video {
    height: 35vw;
  }
  .flex {
    display: flex;
  }
  .f-c {
    flex-direction: column;
  }
  .f-1 {
    flex: 1 0 auto;
  }
  .f-2 {
    flex: 2 0 auto;
  }
  .f-3 {
    flex: 3 0 auto;
  }
  .jc-sb {
    justify-content: space-between;
  }
  .jc-c {
    justify-content: center;
  }
  .jc-e {
    justify-content: flex-end;
  }
  .ai-t {
    align-items: flex-start;
  }
  .ai-c {
    align-items: center;
  }
  .ai-s {
    align-items: stretch;
  }
  .t-c {
    text-align: center;
  }
  .p-b {
    padding-bottom: calc(0.5 * var(--lh));
  }
  .p-none {
    padding: 0 !important;
  }
  .b-t {
    border-top: 1px solid #000 !important;
  }
  .b-b {
    border-bottom: 1px solid #000 !important;
  }
  .b-r {
    border-right: 1px solid #000 !important;
  }
  .b-rw {
    // border-right: 2px solid yellow !important;
  }
  ul {
    list-style: disc !important;
    padding-left: var(--lh);
    margin-bottom: var(--lh);
  }
  .bullet {
    position: relative;
    cursor: pointer;
    padding-left: calc(1 * var(--lh));
    &:before {
      content: "";
      width: calc(0.5 * var(--lh));
      height: calc(0.5 * var(--lh));
      border: 1px solid #000;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translate(0%, -50%);
    }
    &.active,
    &:hover {
      color: black;
      &:before {
        background: black;
      }
    }
  }
  .uc {
    text-transform: uppercase;
  }
  .cap {
    text-transform: capitalize;
  }
}

p {
  font-size: var(--fs);
  line-height: var(--lh);
  margin-bottom: var(--lh);
  &:last-of-type {
    margin-bottom: 0;
  }
}
h1 {
  font-size: calc(2.5 * var(--fs));
  line-height: calc(2.5 * var(--lh));
}
.tnum {
  font-feature-settings: "tnum";
}

input[type="text"],
input[type="number"],
input[type="email"],
input[type="tel"] {
  width: 100%;
  min-width: calc(4 * var(--lh));
  appearance: none;
  background: transparent;
  outline: none;
  border: 0;
  color: black;
  font-size: var(--fs);
  font-family: "Liga", sans-serif;
  &::placeholder {
    color: var(--grey);
  }
}
select {
  width: calc(100% - 2 * var(--lh));
  min-width: calc(4 * var(--lh));
  appearance: none;
  background: transparent;
  outline: none;
  border: 0;
  color: black;
  font-size: var(--fs);
  font-family: "Liga", sans-serif;
  margin: 0 var(--lh);
  &[value] {
    color: black;
  }
  &[value=""] {
    color: var(--grey);
  }
}
@-webkit-keyframes autofill {
  to {
    color: #666;
    background: transparent;
  }
}

input:-webkit-autofill {
  -webkit-animation-name: autofill;
  -webkit-animation-fill-mode: both;
}
</style>
